import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { add_wallpaper_category, update_wallpaper_category } from '../../../../Controller/actions';
import { NewContext } from '../../../../Context/NewContext';

import './wallpapercategoriesform.css';

export const WallpaperCategoriesForm = ({ title }) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { isLoading, setIsLoading, validated, setValidated, updatedData, setUpdatedData } = useContext(NewContext);
    const [backgroundCategories, setBackgroundCategories] = useState({
        name: state ? state.name : "",
        priority: state ? state.priority : "",
        isActive: state ? state.isActive == undefined ? false : state.isActive : false,
    });
    const capitalizeFirstLetter = (str) => {
        let strAry = str.split(" ");
        let strCapitalized = strAry.map(_str => _str.charAt(0).toUpperCase() + _str.slice(1));
        return strCapitalized.join(" ");
    }
    const handleChange = (e) => {
        setUpdatedData({ ...updatedData, [e.target.name]: e.target.name === 'name' ? capitalizeFirstLetter(e.target.value) : e.target.value })
        setBackgroundCategories({ ...backgroundCategories, [e.target.name]: e.target.name === 'name' ? capitalizeFirstLetter(e.target.value) : e.target.value });
    };

    let handleSwitch = (e) => {
        setUpdatedData({ ...updatedData, [e.target.name]: backgroundCategories[e.target.name] ? false : true });
        setBackgroundCategories({ ...backgroundCategories, [e.target.name]: backgroundCategories[e.target.name] ? false : true });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return;
        };
        let createUpdateCategories;
        setIsLoading(true);
        if (state) {
            createUpdateCategories = await update_wallpaper_category(updatedData, state._id)
        } else {
            createUpdateCategories = await add_wallpaper_category(backgroundCategories)
        }
        setIsLoading(false);
        if (createUpdateCategories) {
            const { message, status } = createUpdateCategories;
            if (status) {
                toast.success(message);
                navigate("/wallpapercategories");
                setBackgroundCategories({
                    name: "",
                    priority: "",
                    isActive: false,
                });
                setUpdatedData({});
                setValidated(false);
            } else {
                toast.error(message);
            };
        }

        // var allFieldDone = [];
        // Object.keys(backgroundCategories).map(async (fieldName, i) => {
        //     if (fieldName !== 'id') {
        //         if (backgroundCategories[fieldName].toString().length > 0) {
        //             allFieldDone.push(true);
        //         } else {
        //             allFieldDone.push(false);
        //             toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is Requied!`);
        //         }
        //     }
        // });

        // const aalFieldDone = allFieldDone.every((val, i, arr) => val === true)
        // if (aalFieldDone) {
        //     let createUpdateCategories;
        //     setIsLoading(true);
        //     if (state) {
        //         createUpdateCategories = await update_wallpaper_category(backgroundCategories, state._id)
        //     } else {
        //         createUpdateCategories = await add_wallpaper_category(backgroundCategories)
        //     }
        //     setIsLoading(false);
        //     if (createUpdateCategories) {
        //         const { message, status } = createUpdateCategories;
        //         if (status) {
        //             toast.success(message);
        //             navigate("/backgroundcategories");
        //             setBackgroundCategories({
        //                 id: "",
        //                 name: "",
        //                 priority: "",
        //                 isActive: false,
        //             });
        //         } else {
        //             toast.error(message);
        //         };
        //     }
        // }
    };

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`;
        setUpdatedData({});
    }, []);

    return (
        <div className='addslider-main p-3'>
            <div className='sliders-header mb-3 d-flex justify-content-between'>
                <h3>{state ? `Edit Background Categories` : `Add Background Categories`}</h3>
            </div>
            <Row>
                <Col md={8} lg={9}>
                    <Form noValidate validated={validated} onSubmit={handleSubmit} method="POST">
                        <Row className='mb-3'>
                            <Col lg={12} className="mb-3">
                                <Row>
                                    <Form.Label htmlFor='background_categories_name' column md={3} sm={4}>Name</Form.Label>
                                    <Col><Form.Control id='background_categories_name' type="text" placeholder="Enter name" name='name' onChange={handleChange} value={updatedData.name ? updatedData.name : backgroundCategories.name} required /></Col>
                                </Row>
                            </Col>
                            <Col lg={12} className="mb-3">
                                <Row>
                                    <Form.Label htmlFor='background_categories_priority' column md={3} sm={4}>Priority</Form.Label>
                                    <Col><Form.Control id='background_categories_priority' type="text" placeholder="Enter priority" name='priority' onChange={handleChange} value={updatedData.priority ? updatedData.priority : backgroundCategories.priority} required /></Col>
                                </Row>
                            </Col>
                            <Col lg={12} className="mb-3">
                                <Row className='align-items-center'>
                                    <Form.Label htmlFor='background_categories_isActive' column md={3} sm={4}>Active</Form.Label>
                                    <Col><Form.Check type="switch" id="background_categories_isActive" name='isActive' onChange={handleSwitch} checked={updatedData.isActive ? updatedData.isActive : backgroundCategories.isActive} role="button" /></Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className='justify-content-end'>
                            <Col lg={12}>
                                <Row className='align-items-center'>
                                    <Col lg={3} md={3} sm={4}></Col>
                                    <Col>
                                        <Button variant="primary" type="submit" className='px-5 me-3' style={{ width: "150px" }}>
                                            {isLoading ? <Spinner animation="border" size="sm" /> : state ? `Update` : `Submit`}
                                        </Button>
                                        <Button variant="danger" className='w-auto px-5' onClick={() => navigate(-1)}>{`Back`}</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
};

WallpaperCategoriesForm.defaultProps = {
    title: "Categories Form"
};

export default WallpaperCategoriesForm;